import AddPostContainer from "../../../../Components/Miscellaneous/Blog/AddPost/AddPostContainer";

const AddPost = () => {
  return <AddPostContainer />;
};

export default AddPost;
